<template>
    <div>
        <multiselect class="form-control" v-model="modelo.idusuario" :options="datos" track-by="id" 
        label="nombres" :hide-selected="false" 
            :searchable="true" :close-on-select="false" :multiple="multiple" :show-labels="false" 
            placeholder="Seleccione asesores...">
            
            <template slot="tag" slot-scope="{ option, remove }">
                        <div>
                          <span class="custom__tag">
                            <span class="custom__remove" @click="remove(option)">❌</span>
                            <span> {{option.nombres}} </span>
                          </span>
                        </div>
                      </template>
            <span slot="noResult">Estudiante no encontrado</span>
        </multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
export default {
    props:{ 
        model:Object,
        models:{type:Object,required:false},
        idsede:{type:Number,required:false},
        xdefault:{type:Array,required:false},
        multiple:{type:Boolean,required:false,default:false} 
    },
    data(){
        return{
            datos: [],
            modelo: {
                idusuario: null,
            }
        }
    },
    watch:{
        'modelo.idusuario': function(){
            if( this.models != null ){
                this.models.usuarios = this.modelo.idusuario; 
            }else{
                this.model.idusuario = this.modelo.idusuario; 
            }
        },
        'idsede': function(){
          this.getDatos();
        },
        xdefault:{
          deep: true,
          handler(){
            window.console.log( "slkdhsdkhfkjsdhfjkshdfjkhfds",this.modelo )
            this.modelo.idusuario = this.xdefault;
          }
        },
    },
    methods:{
        async getDatos() {
            if( this.idsede == null ){
                return;
            }
            var vue = this;
            var sql = gql`query{ getSede(id:${this.idsede}){usuarios_activos{usuario{estado,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{idcargo}}}} }`;
            window.console.log( sql )
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var sed = data.data.getSede;
                var datas = [];
                var los_que_tambien_inscriben = [];
                if( sed.usuarios_activos == null ) return;
                sed.usuarios_activos.forEach( function(e){
                    var dp = e.usuario.datos_personales;
                    var seg = dp.seg_apellido==null?'':dp.seg_apellido;
                    var no = dp.nombres+" "+dp.pri_apellido+" "+seg;
                    var isMarketing = e.usuario.cargos.find( x => (x.idcargo == 11 || x.idcargo == 12 || x.idcargo == 13) )
                    var tambien = e.usuario.cargos.find( x => (x.idcargo >= 4 && x.idcargo <= 15) )
                    if( isMarketing && e.usuario.estado ) {
                        datas.push({ id:dp.id,nombres:no });
                    }else if( tambien && e.usuario.estado ){
                        los_que_tambien_inscriben.push({ id:dp.id,nombres:no });
                    }
                    
                });

                const uniqueArray = datas.filter((thing, index) => {
                    const _thing = JSON.stringify(thing);
                        return index === datas.findIndex(obj => {
                            return JSON.stringify(obj) === _thing;
                        });
                });
                datas = uniqueArray;

                vue.datos = datas.concat( los_que_tambien_inscriben );
                vue.modelo.idusuario = datas;
                
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getSede' ) )
            })
        },
    },
    mounted(){
        this.getDatos();
        if( this.xdefault ){
          this.modelo.idusuario = this.xdefault;
        //   window.console.log( "-------------------------------------",this.modelo );
        }
    }
}
</script>